module.exports = __webpack_public_path__ + "static/img/5.985d739.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/article/5.jpg
// module id = 3q0L
// module chunks = 1